import { WidgetPositioning } from "@src/types/dashboards";

/**
 * First-fit top-left placement: scan rows top→bottom, columns left→right, and
 * return the earliest x,y where a w×h box doesn't overlap any occupied box.
 * Since the size is known up front, this packs compactly and fills gaps left by
 * removed widgets — preferable to always appending below.
 */
export const findFreeSlot = (
  occupied: WidgetPositioning[],
  columns: number,
  w: number,
  h: number,
): { x: number; y: number } => {
  const width = Math.min(w, columns);
  const overlaps = (x: number, y: number) =>
    occupied.some(
      (o) => x < o.x + o.w && x + width > o.x && y < o.y + o.h && y + h > o.y,
    );

  for (let y = 0; ; y++) {
    for (let x = 0; x <= columns - width; x++) {
      if (!overlaps(x, y)) return { x, y };
    }
  }
};
